import React from "react";
import { Link, useMatch, useNavigate } from "react-router-dom";
import {
  WhatsAppIcon,
  LangIcon,
  Arrow,
  Calculator,
  GiftIcon,
  CartIcon,
} from "../Images/svgs";
import DropDown from "./Partials/DropDown";
import { useDispatch, useSelector } from "react-redux";
import { toggleDropdown, setSelectedValue } from "../Managment/Slice";
import Popup from "reactjs-popup";
import DonateNow from "../Components/Partials/DonateNow";
import SideBar from "../Components/SideBar";

function Navbar() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Get data from Redux
  const showlists = useSelector((state) => state.dropdown.showlists);
  const selectedValues = useSelector((state) => state.dropdown.selectedValues);

  const handleSelect = (value, index) => {
    dispatch(setSelectedValue({ index, value }));
  };

  const toggleDropDown = (e, index) => {
    e.stopPropagation(); // Prevents immediate closing from the document listener
    dispatch(toggleDropdown({ index }));
  };

  const currencies = [
    { text: "$ دولار امريكي" },
    { text: "₺ ليرة تركية" },
    { text: "€ يورو" },
  ];
  const language = [{ text: "عربي" }, { text: "تركي" }, { text: "انجليزي" }];

  return (
    <div className="w-full border-b bg-white sticky top-0 z-[100]">
      <div className="container max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Desktop Nav - Hidden on mobile, visible on medium screens and up */}
        <div className="hidden md:flex justify-between items-center py-4">
          {/* Section 1: Contact */}
          <div className="flex items-center gap-3">
            <WhatsAppIcon />
            <a
              href="tel:+447360931094"
              className="text-black font-bold dir-ltr text-base hover:text-gray-700 transition-colors"
            >
              +447360931094
            </a>
          </div>

          {/* Section 2: Dropdowns */}
          <div className="flex items-center gap-3">
            <ul className="flex flex-row items-center gap-3">
              {/* Currency Dropdown */}
              <li
                className="relative cursor-pointer flex flex-row gap-2 items-center text-black px-4 py-2 border border-gray-200 rounded-md font-medium hover:bg-gray-50 text-sm"
                onClick={(e) => toggleDropDown(e, 0)}
              >
                <span>{selectedValues[0] || "$ دولار امريكي"}</span>
                <Arrow />
                <DropDown
                  links={currencies}
                  isOpen={showlists[0]}
                  onSelect={(value) => handleSelect(value, 0)}
                  dropdownId={0}
                />
              </li>

              {/* Language Dropdown */}
              <li
                className="relative cursor-pointer flex flex-row gap-2 items-center text-black px-4 py-2 border border-gray-200 rounded-md font-medium hover:bg-gray-50 text-sm"
                onClick={(e) => toggleDropDown(e, 1)}
              >
                <LangIcon />
                <span>{selectedValues[1] || "عربي"}</span>
                <Arrow />
                <DropDown
                  links={language}
                  isOpen={showlists[1]}
                  onSelect={(value) => handleSelect(value, 1)}
                  dropdownId={1}
                />
              </li>
            </ul>
          </div>

          {/* Section 3: Actions */}
          <div className="flex items-center gap-3">
            <Link
              to="/zaka-calculator"
              className="text-black px-4 py-2 border border-black rounded-md flex items-center gap-2 hover:bg-gray-50 transition-colors text-sm"
            >
              <Calculator />
              <span className="font-semibold whitespace-nowrap">
                حاسبة الزكاة
              </span>
            </Link>

            <Link
              to="/gift"
              className="flex items-center justify-center bg-blue-500 hover:bg-blue-600 rounded-md p-2 transition-colors"
            >
              <GiftIcon />
            </Link>

            <Popup
              trigger={
                <button className="text-black px-6 py-2 bg-yellow-400 hover:bg-yellow-500 rounded-md font-bold transition-colors text-sm">
                  تبرع الآن
                </button>
              }
              modal
              contentStyle={{
                width: "fit-content",
                borderRadius: "12px",
                border: "none",
              }}
            >
              <DonateNow popup={true} />
            </Popup>
          </div>

          {/* Section 4: Auth */}
          <div className="flex items-center gap-2">
            <div className="p-2 border border-gray-200 rounded-md hover:bg-gray-50 cursor-pointer">
              <CartIcon />
            </div>
            <Link
              to="/join"
              className="text-white px-4 py-2 bg-black rounded-md font-semibold hover:opacity-80 text-sm"
            >
              انضم الينا
            </Link>
            <Link
              to="/register"
              className="text-white px-4 py-2 bg-blue-700 rounded-md font-semibold hover:bg-blue-800 text-sm"
            >
              تسجيل
            </Link>
          </div>
        </div>

        {/* Mobile Nav - Hidden on all screens since you want navbar hidden on mobile */}
        <SideBar />
      </div>
    </div>
  );
}

export default Navbar;
